var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',_vm._l((_vm.items),function(item){return _c('li',[_c('segmented-content',{attrs:{"content":item}}),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }